/**
 * Generated by orval 🍺
 * Do not edit manually.
 * User Management Users API
 * UserManagement bounded-context contract for user administration.
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary List users
 */

export const listUserManagementUsersQueryPerPageMax = 100;

export const listUserManagementUsersQuerySortDirDefault = `asc`;

export const ListUserManagementUsersQueryParams = zod.object({
  page: zod.coerce.number().int().min(1).describe("Page number (1-indexed)"),
  perPage: zod.coerce
    .number()
    .int()
    .min(1)
    .max(listUserManagementUsersQueryPerPageMax)
    .describe("Number of items per page"),
  q: zod.coerce.string().optional().describe("Free-text search query"),
  sortKey: zod
    .enum(["userId", "displayName", "createdAt", "updatedAt"])
    .optional()
    .describe("User sort key"),
  sortDir: zod
    .enum(["asc", "desc"])
    .default(listUserManagementUsersQuerySortDirDefault)
    .describe("Sort direction"),
  accessState: zod
    .enum(["PENDING_ACTIVATION", "ACTIVE", "SUSPENDED"])
    .optional()
    .describe("User access state"),
  invitationState: zod
    .enum([
      "NOT_REQUESTED",
      "REQUESTED",
      "DISPATCH_ACCEPTED",
      "WAITING_FOR_USER",
      "ACCEPTED",
      "EXPIRED",
    ])
    .optional()
    .describe("User invitation state"),
  identityBindingState: zod
    .enum(["UNBOUND", "BOUND", "CONFLICT", "REPLACEMENT_REQUIRED"])
    .optional()
    .describe("User identity binding state"),
  provisioningStatus: zod
    .enum(["PENDING", "LEASED", "RETRY_WAITING", "RECONCILIATION_REQUIRED", "COMPLETED"])
    .optional()
    .describe("User provisioning status"),
});

export const listUserManagementUsersResponseMetaTotalMin = 0;

export const ListUserManagementUsersResponse = zod.object({
  items: zod.array(
    zod.object({
      userId: zod.uuid(),
      accessState: zod.enum(["PENDING_ACTIVATION", "ACTIVE", "SUSPENDED"]),
      invitationState: zod.enum([
        "NOT_REQUESTED",
        "REQUESTED",
        "DISPATCH_ACCEPTED",
        "WAITING_FOR_USER",
        "ACCEPTED",
        "EXPIRED",
      ]),
      identityBindingState: zod.enum(["UNBOUND", "BOUND", "CONFLICT", "REPLACEMENT_REQUIRED"]),
      externalAccountAssociated: zod.boolean(),
      lifecycleEpoch: zod.int(),
      currentOperationId: zod.uuid(),
      displayName: zod.string(),
      profileRevision: zod.int(),
      locale: zod.string().nullish(),
      timeZone: zod.string().nullish(),
      settingsRevision: zod.int(),
      provisioningOperationId: zod.uuid(),
      provisioningIntent: zod.enum(["INVITE", "RESEND", "SUSPEND", "REACTIVATE"]),
      provisioningStatus: zod.enum([
        "PENDING",
        "LEASED",
        "RETRY_WAITING",
        "RECONCILIATION_REQUIRED",
        "COMPLETED",
      ]),
      provisioningRevision: zod.int(),
      createdAt: zod.iso.datetime({offset: true}),
      updatedAt: zod.iso.datetime({offset: true}),
    }),
  ),
  meta: zod.object({
    total: zod
      .int()
      .min(listUserManagementUsersResponseMetaTotalMin)
      .describe("Total count of items matching query ignoring pagination"),
    page: zod.int().min(1).describe("Current page number"),
    perPage: zod.int().min(1).describe("Number of items returned per page"),
  }),
});

/**
 * @summary Invite user
 */
export const InviteUserManagementUserHeader = zod.object({
  "Idempotency-Key": zod.uuid().describe("UUID idempotency key"),
});

export const inviteUserManagementUserBodyUsernameMax = 255;

export const inviteUserManagementUserBodyUsernameRegExp = new RegExp("^[A-Za-z0-9._-]+$");

export const InviteUserManagementUserBody = zod.object({
  displayName: zod.string().min(1),
  email: zod.email().min(1),
  username: zod
    .string()
    .min(1)
    .max(inviteUserManagementUserBodyUsernameMax)
    .regex(inviteUserManagementUserBodyUsernameRegExp),
});

export const InviteUserManagementUserResponse = zod.uuid();

/**
 * @summary Activate current user
 */
export const ActivateCurrentUserManagementUserResponse = zod.void();

/**
 * @summary Get user
 */
export const GetUserManagementUserResponse = zod.object({
  userId: zod.uuid(),
  accessState: zod.enum(["PENDING_ACTIVATION", "ACTIVE", "SUSPENDED"]),
  invitationState: zod.enum([
    "NOT_REQUESTED",
    "REQUESTED",
    "DISPATCH_ACCEPTED",
    "WAITING_FOR_USER",
    "ACCEPTED",
    "EXPIRED",
  ]),
  identityBindingState: zod.enum(["UNBOUND", "BOUND", "CONFLICT", "REPLACEMENT_REQUIRED"]),
  externalAccountAssociated: zod.boolean(),
  lifecycleEpoch: zod.int(),
  currentOperationId: zod.uuid(),
  displayName: zod.string(),
  profileRevision: zod.int(),
  locale: zod.string().nullish(),
  timeZone: zod.string().nullish(),
  settingsRevision: zod.int(),
  provisioningOperationId: zod.uuid(),
  provisioningIntent: zod.enum(["INVITE", "RESEND", "SUSPEND", "REACTIVATE"]),
  provisioningStatus: zod.enum([
    "PENDING",
    "LEASED",
    "RETRY_WAITING",
    "RECONCILIATION_REQUIRED",
    "COMPLETED",
  ]),
  provisioningRevision: zod.int(),
  createdAt: zod.iso.datetime({offset: true}),
  updatedAt: zod.iso.datetime({offset: true}),
});

/**
 * @summary Resend user invitation
 */
export const ResendUserManagementInvitationHeader = zod.object({
  "Idempotency-Key": zod.uuid().describe("UUID idempotency key"),
});

export const ResendUserManagementInvitationResponse = zod.uuid();

/**
 * @summary Suspend user
 */
export const SuspendUserManagementUserHeader = zod.object({
  "Idempotency-Key": zod.uuid().describe("UUID idempotency key"),
});

export const SuspendUserManagementUserResponse = zod.void();

/**
 * @summary Request user reactivation
 */
export const ReactivateUserManagementUserHeader = zod.object({
  "Idempotency-Key": zod.uuid().describe("UUID idempotency key"),
});

export const ReactivateUserManagementUserResponse = zod.void();

/**
 * @summary Update user profile
 */

export const updateUserManagementProfileBodyExpectedRevisionMin = 0;

export const UpdateUserManagementProfileBody = zod.object({
  displayName: zod.string().min(1),
  expectedRevision: zod.int().min(updateUserManagementProfileBodyExpectedRevisionMin),
});

export const UpdateUserManagementProfileResponse = zod.void();
